<template>
  <div class="relative">
    <div class="space-y-6 p-6 text-ontick-steel-900 dark:text-gray-300">
      <header-component />
      <div class="space-y-2">
        <h1 class="text-xl font-bold">Parceiros</h1>
        <p class="text-sm">Conheça as extensões dos parceiros OnTick</p>
      </div>
      <template v-if="isLoading">
        <div class="flex h-64 w-full items-center justify-center">
          <div class="animate-spin">
            <i v-html="$icons.spinner_lg"></i>
            <span class="sr-only">Carregando</span>
          </div>
        </div>
      </template>
      <template v-else-if="partners.length">
        <!-- CARD -->
        <transition name="fade">
          <div class="">
            <transition-group
              name="company"
              class="grid-auto-rows relative grid grid-cols-1 gap-6 pb-16 transition-all duration-100 ease-in-out sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4"
            >
              <template v-if="getSearchFilter">
                <card-component
                  v-for="item in filteredExtensions"
                  :key="item.extension_id"
                  :data="item"
                  @subscription="getData"
                />
              </template>
              <template v-else>
                <partner-card-component
                  v-for="(item, idx) in uniquePartners"
                  :key="`${idx}-${item.partner_name}`"
                  :data="item"
                  :multiple="partners.filter((partner) => partner.partner_name === item.partner_name).length > 1"
                  @action="openTab(item.extension_group)"
                  :blackFriday="item.plans.some((item) => item.extension_black_friday)"
                  class="h-full"
                />
              </template>
            </transition-group>
          </div>
        </transition>
      </template>
      <div v-else class="flex h-full w-full items-center justify-center space-x-6 pt-12">
        <span v-html="filter" class="scale-75 transform"></span>
        <div>
          <p class="text-2xl font-bold">Nenhum resultado encontrado</p>
        </div>
      </div>
    </div>
    <filters-component />
    <filter-tab-component :active="tabIsActive" :title="selectedGroup" @close="tabIsActive = false" size="xl">
      <div class="grid w-full grid-cols-1 gap-4 sm:grid-cols-2">
        <partner-card-component
          v-for="item in selectedExtensions"
          :logo="item.plans[0].extension_logo"
          :key="item.extension_group"
          :data="item"
          :isExtension="true"
          @action="goToExtensionPage(item.extension_group)"
        />
      </div>
    </filter-tab-component>
    <!-- <preferences-modal-component v-if="getPreferencesModalIsActive" /> -->
  </div>
</template>

<script>
// import PreferencesModalComponent from "../../components/extension/preferences-modal.component.vue";
import { mapActions, mapGetters } from "vuex";
import DetailsComponent from "../../components/extension/details.component.vue";
import HeaderComponent from "../../components/header.component.vue";
import CardComponent from "../../components/extension/card.component.vue";
import ListItemComponent from "../../components/extension/list-item.component.vue";
import FiltersComponent from "../../components/filters.component.vue";
import { filter } from "../../../../assets/icons/isometric";
import PartnerCardComponent from "../../components/partners/partner-card.component.vue";
import FilterTabComponent from "../../../../shared/components/filters/filter-tab.component.vue";
import OntickDiscountBadgeComponent from "../../../../shared/components/basic/ontick-discount-badge.component.vue";
export default {
  components: {
    // PreferencesModalComponent,
    HeaderComponent,
    CardComponent,
    DetailsComponent,
    ListItemComponent,
    FiltersComponent,
    PartnerCardComponent,
    FilterTabComponent,
    OntickDiscountBadgeComponent,
  },
  data() {
    return {
      partners: [],
      uniquePartners: [],
      isLoading: false,
      tabIsActive: false,
      selectedGroup: "",
      filter,
      interval: null,
    };
  },
  computed: {
    ...mapGetters({
      // getTableMode: "partners/getTableMode",
      // getDetailsIsActive: "partners/getDetailsIsActive",
      getSearchFilter: "partners/getSearchFilter",
      getSelectedAccount: "accountTypes/getSelectedAccount",
      // getActiveFilters: "partners/getActiveFilters",
      // getPreferencesModalIsActive: "partners/getPreferencesModalIsActive",
    }),

    selectedExtensions() {
      return this.partners.filter((item) => item.partner_name === this.selectedExtension.partner_name);
    },

    extensions() {
      const arr = [];
      this.partners.forEach((item) => arr.push(item.extensions));
      return arr.flat();
    },

    filteredExtensions() {
      let arr = [];
      this.partners.forEach((item) =>
        arr.push(
          item.plans.map((plan) => {
            return {
              ...plan,
              extension_name: item.extension_name,
              extension_group: item.extension_group,
            };
          })
        )
      );
      const plans = arr.flat();
      const filtered = (value) => {
        return value.toLowerCase().startsWith(this.getSearchFilter.toLowerCase());
      };
      return plans.filter((item) => filtered(item.extension_name) || filtered(item.extension_plan_name));
    },

    selectedExtension() {
      const selected = this.partners.find((item) => item.extension_group === this.selectedGroup);
      return selected ? selected : {};
    },
  },
  methods: {
    ...mapActions({
      // setDetailsIsActive: "partners/setDetailsIsActive",
      clearFilters: "partners/clearFilters",
      setUserConfig: "config/setUserConfig",
      fetchAccounts: "accountTypes/fetchAccounts",
    }),
    goToExtensionPage(group) {
      this.$router.push({
        name: "Detalhes da extensão",
        params: {
          partner_name: this.selectedExtension.partner_name.toLowerCase().replaceAll(" ", ""),
          extension_group: group,
        },
      });
    },
    openTab(group) {
      this.selectedGroup = group;

      if (this.partners.filter((item) => item.partner_name === this.selectedExtension.partner_name).length === 1) {
        this.goToExtensionPage(this.selectedGroup);
      } else if (this.partners.filter((item) => item.partner_name === this.selectedExtension.partner_name).length > 1) {
        this.tabIsActive = true;
      }
    },
    getConfig() {
      return new Promise((resolve, reject) => {
        this.$api
          .get(this.$endpoint.USER_CONFIGS)
          .then((response) => {
            this.setUserConfig(response.data);
            this.fetchAccounts(response.data.accounts);
            resolve();
          })
          .catch((error) => {
            if (error.data.status == "error") {
              this.setUserConfig(error.data);
            }
            reject();
          });
      });
    },
    getData() {
      return this.$api
        .get(this.$endpoint.LIST_EXTENSIONS, {
          params: {
            account_id: this.getSelectedAccount.account_id,
          },
        })
        .then((res) => {
          // console.log(res.data);
          this.partners = res.data.filter(
            (item) => !["Felipe Perigolo", "Martha Matsumura"].includes(item.extension_name)
          );
          const arr = [];
          this.partners.forEach((item) => {
            // const index = arr.findIndex(
            //   (arrItem) =>
            //     item.partner_name === arrItem.partner_name &&
            //     arrItem.plans.length
            // );
            // if (index === -1) {
            //   arr.push(item);
            // }
            arr.push(JSON.stringify(item));
          });
          this.uniquePartners = Array(...new Set(arr.map((item) => JSON.parse(item))));
          this.getConfig();
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  mounted() {
    this.isLoading = true;

    const callData = () => {
      if (this.getSelectedAccount.account_id && typeof this.getSelectedAccount.account_id === "number") {
        this.getData()
          .then(() => {
            this.isLoading = false;
          })
          .finally(() => {
            clearInterval(this.interval);
          });
      } else {
        this.interval = setInterval(() => {
          callData();
        }, 1000);
      }
    };

    callData();
  },
  unmounted() {
    this.clearFilters();
  },
};
</script>

<style lang="scss" scoped>
.list-bg {
  @apply text-ontick-steel-900 transition-all dark:text-gray-300 dark:hover:text-white;
  &:nth-child(odd) {
    @apply bg-ontick-steel-100 dark:bg-ontick-graphite-600;
  }
  &:nth-child(even) {
    @apply bg-gray-50 dark:bg-ontick-graphite-500;
  }
  &:first-child {
    @apply rounded-t-xl;
  }
  &:last-child {
    @apply rounded-b-xl;
  }
}
.fade {
  &-enter,
  &-leave-to {
    @apply opacity-0;
  }
  &-enter-active,
  &-leave-active {
    @apply transition-all duration-300;
  }
  &-enter-to,
  &-leave {
    @apply opacity-0;
  }
}

.company {
  &-move {
    transition: all 600ms ease-in-out 50ms;
  }
  &-enter-active {
    transition: all 300ms ease-out;
  }

  &-leave-active {
    transition: all 500ms ease-in-out;
    position: absolute;
    z-index: 50;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
  &-enter {
    transform: scale(0.9);
  }
}
</style>
